const imageTransformator = {
  toModelAttribute(value) {
    if (value == null || typeof value !== "object") {
      return null;
    }

    if (value.remove) {
      return false;
    }

    return value.uploadResponse;
  },

  toFormAttribute(value) {
    if (value == null || typeof value !== "object") {
      return null;
    }

    if (value.remove) {
      return false;
    }

    return value.preview;
  },
};

export default imageTransformator;
